module.exports = __webpack_public_path__ + "static/img/logo.b6c3755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 380
// module chunks = 1